<ng-container *ngIf="open else closed">
  @if (status) {
    <aaa-text size="caption" display="inline" color="valid">{{ status }}</aaa-text>
  } @else {
    <aaa-text i18n size="caption" display="inline" color="success" class="open">Open</aaa-text>
  }
</ng-container>
<ng-template #closed>
  <aaa-text i18n size="caption" display="inline" color="text" class="closed">Closed</aaa-text>
</ng-template>
